import { User } from "@fairfleet/geotab";
import { useGroupByName } from "../groups/useGroupByName";
import { licenseStatusOf } from "./licenseStatus";
import { useDatabaseHash } from "./useDatabaseHash";

/**
 * Whether one page is licensed.
 *
 * The answer comes from {@link licenseStatusOf}, the same comparison the launcher uses for every
 * page at once, so the rule about who may open what lives in one place. Reported as the numbers
 * this hook has always reported: 0 while it is not known, 1 licensed, -1 not.
 */
export function useLicenseCheck(groupName: string, user: User | null) {
  const { data: dmGroup, isLoading: isDmGroupLoading, isFetched } = useGroupByName(groupName);
  const { data: databaseHash } = useDatabaseHash();

  const status = licenseStatusOf({
    isDev: import.meta.env.DEV,
    userName: user?.name,
    groupComments: dmGroup?.comments ?? null,
    // Without a user there is nobody to decide about yet.
    groupFetched: !!user && isFetched,
    databaseHash,
  });

  const licensedState = status === "pending" ? 0 : status === "licensed" ? 1 : -1;

  return { licensedState, isDmGroupLoading };
}
